import { useLanguage } from '@/contexts/language-context';

import { ConfigModal } from './config-modal';
import { CashLogo, CheckLogo, ZelleLogo, VenmoLogo } from './logos';
import type { MethodType } from './types';

interface Props {
  onSelect: (method: MethodType) => void;
  onClose: () => void;
}

export function MethodPickerModal({ onSelect, onClose }: Props) {
  const { t } = useLanguage();

  const methods = [
    { type: 'zelle' as const, Logo: ZelleLogo, title: t.zelleTitle, description: t.zelleDescription },
    { type: 'venmo' as const, Logo: VenmoLogo, title: t.venmoTitle, description: t.venmoDescription },
    { type: 'cash' as const, Logo: CashLogo, title: t.cashTitle, description: t.cashDescription },
    { type: 'check' as const, Logo: CheckLogo, title: t.checkTitle, description: t.checkDescription },
  ];

  return (
    <ConfigModal title={t.chooseMethodToAdd} onClose={onClose}>
      <div className="flex flex-col gap-2">
        {methods.map(({ type, Logo, title, description }) => (
          <button
            key={type}
            onClick={() => onSelect(type)}
            className="flex items-center gap-4 p-3 rounded-lg border border-border hover:bg-muted transition-colors text-left"
            data-testid={`pick-${type}`}
          >
            <Logo className="w-10 h-10 shrink-0" />
            <div>
              <p className="font-medium text-sm">{title}</p>
              <p className="text-xs text-muted-foreground">{description}</p>
            </div>
          </button>
        ))}
      </div>
    </ConfigModal>
  );
}
